import React, { FC, useCallback } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DraggableItem } from "./DraggableItem";
import { Box, Divider, ThemeProvider, createTheme } from "@mui/material";

export type Props = {
  items: any[];
  setItem: (value: any) => void;
  onDrop?: () => void;
  Styledcard: any;
  selected?: number;
  className?: string;
};

const theme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          // fontSize: '1rem',
          // width:'10%'
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          fontSize: 20,
        },
      },
    },
  },
});

const DraggableList: FC<Props> = React.memo(
  ({ items, setItem, Styledcard, onDrop, ...props }) => {
    // MOVE CARD
    const moveCard = useCallback((dragIndex: number, hoverIndex: number) => {
      setItem({ dragIndex, hoverIndex });
    }, []);

    // RENDER CARD
    const renderCard = useCallback(
      (card: any, index: number, Styledcard) => {
        return (
          <React.Fragment key={card.displayOrder?.toString()}>
            <DraggableItem
              key={card.displayOrder?.toString()}
              index={index}
              id={card.index}
              moveCard={moveCard}
              isSelected={
                props?.selected?.toString() === card?.displayOrder?.toString()
              }
              onDrop={() => {
                if (onDrop) onDrop();
              }}
            >
              <Styledcard item={card} />
            </DraggableItem>
            <Divider />
          </React.Fragment>
        );
      },
      [props?.selected]
    );

    return (
      <>
        <DndProvider backend={HTML5Backend}>
          <ThemeProvider theme={theme}>
            <Box className={props?.className || ""}>
              {items
                ?.sort((a, b) => a.displayOrder - b.displayOrder)
                ?.map((card, i) => renderCard(card, i, Styledcard))}
            </Box>
          </ThemeProvider>
        </DndProvider>
      </>
    );
  }
);

export default DraggableList;
